import { createReducer, on } from '@ngrx/store';
import { News } from '../../models';
import * as pageActions from '../actions/news.action';
import { ToEntities } from '@teamfoster/sdk/array-utility';
import { PageData } from 'src/app/standalone/models/page-data.model';

export interface NewsState {
  entities: { [id: number]: News };
  page: PageData;
  loaded: number[];
  loading: number[];
  overviewLoaded: boolean;
  overviewLoading: boolean;
  error?: any;
}

export const initialState: NewsState = {
  entities: {},
  page: { currentPage: 0, pageCount: 0, resultCount: 0, pageSize: 5, filters: {} },
  loaded: [],
  loading: [],
  overviewLoaded: false,
  overviewLoading: false,
};

export const NewsReducer = createReducer(
  initialState,

  on(pageActions.LoadNewsOverview, (state: NewsState) => {
    return {
      ...state,
      overviewLoading: true,
    };
  }),
  on(pageActions.LoadNewsOverviewSuccess, (state: NewsState, { News }) => {
    const entities = ToEntities(News.items, 'id', {});

    return {
      ...state,
      entities,
      page: News.page,
      overviewLoading: false,
      overviewLoaded: true,
    };
  }),
  on(pageActions.LoadMoreNewsSuccess, (state: NewsState, { News }) => {
    const entities = ToEntities(News.items, 'id', state.entities);
    return {
      ...state,
      entities,
      page: News.page,
      overviewLoading: false,
      overviewLoaded: true,
    };
  }),
  on(pageActions.LoadNewsOverviewFail, (state: NewsState, { error }) => {
    return {
      ...state,
      overviewLoading: false,
      overviewLoaded: false,
      error,
    };
  }),
  on(pageActions.LoadNewsById, (state: NewsState, { id }) => {
    return {
      ...state,
      loading: [...state.loading, id],
    };
  }),
  on(pageActions.LoadNewsByIdSuccess, (state: NewsState, { Item }) => {
    const entities = { ...state.entities, [Item.id]: Item };
    return {
      ...state,
      entities,
      loading: state.loading.filter(id => id !== Item.id),
      loaded: [...state.loaded, Item.id],
    };
  }),
  on(pageActions.LoadNewsByIdFail, (state: NewsState, { error, id }) => {
    return {
      ...state,
      loading: state.loading.filter(id => id !== id),
      loaded: state.loaded.filter(id => id !== id),
      error,
    };
  })
);

export const getNewsEntities = (state: NewsState) => state.entities;
export const getNewsLoading = (state: NewsState) => state.loading;
export const getNewsLoaded = (state: NewsState) => state.loaded;
export const getNewsOverviewLoading = (state: NewsState) => state.overviewLoading;
export const getNewsOverviewLoaded = (state: NewsState) => state.overviewLoaded;
export const getNewsPage = (state: NewsState) => state.page;
export const getNewsError = (state: NewsState) => state.error;
